module.exports = __webpack_public_path__ + "static/media/S3N4-3.39416deb.svg";